import HtmlTooltip from "@mui/material/Tooltip";
import format from "date-fns/format";
import React, { useState } from "react";
import { BiInfoCircle } from "react-icons/bi";
import { HiOutlineClock, HiOutlineTicket, HiQrcode } from "react-icons/hi";
import { Ticket } from "../../../models/Ticket";
import "./style.scss";
import ModalComponent from "../../../../features/ModalComponent";
import QrCodeModal from "../../../../features/QRcode";
import { useTranslation } from "react-i18next";
import EAButton from "../../shared/Buttons/EAButton";

interface IProps {
  ticket: Ticket;
}

const LimitedTicketDesktop: React.FC<IProps> = ({ ticket }: IProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <React.Fragment>
      <div className="purchased-assort">
        <div className="purchased-assort_left">
          <div className="purchased-assort_startIcon">
            <HiOutlineTicket className="myAccount-ticketLine_icon" />
          </div>

          <div className="purchased-assort_body">
            <h5>
              {ticket.name}
              {ticket.description.length > 10 && (
                <HtmlTooltip
                  placement="right"
                  title={
                    <React.Fragment>
                      <article
                        className="tooltip-description"
                        dangerouslySetInnerHTML={{ __html: ticket.description }}
                      ></article>
                    </React.Fragment>
                  }
                >
                  <b>
                    <BiInfoCircle className="tooltip-icon" />
                  </b>
                </HtmlTooltip>
              )}
            </h5>
            <span className="purchased-assort_body__details">
              <HiOutlineClock /> {t("wazny_od")}:{" "}
              <b>
                {format(ticket.validfrom, "dd.MM.yyyy")}r. | {t("wazny_do")}: {format(ticket.validto, "dd.MM.yyyy")}r.
              </b>
            </span>
          </div>
        </div>

        <div className="purchased-assort_action">
          <EAButton title={t("pokaz_kod_qr")} onClick={() => setOpen(!open)} fullWidth endIcon={<HiQrcode />} />
        </div>
      </div>

      {open && (
        <ModalComponent
          footer={false}
          open={open}
                    leftType="exercise"
          closeModal={() => setOpen(false)}
          title={t("kod_qr")}
          onAccept={() => setOpen(false)}
        >
          <QrCodeModal trhId={ticket.trhId} name={ticket.name} />
          <EAButton title={t("gotowe_schowaj")} onClick={() => setOpen(!open)} fullWidth />
        </ModalComponent>
      )}
    </React.Fragment>
  );
};

export default LimitedTicketDesktop;
